<script>
import { list } from '@/api/empresa'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ nome_empresa: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="nome_empresa"
    width="1000"
    component="app-empresa-grid"
    label="Nome Empresa"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
